module.exports = __webpack_public_path__ + "static/me.cab06843.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/me.jpeg
// module id = 773
// module chunks = 212839066777427